import React from "react";
import WaypointSummary from "./WaypointSummary";
import WaypointDetailed from "./WaypointDetailed";

export interface Waypoint {
    companyName: string;
    contactName: string;
    contactTelephone: string;
    address: {
        suburb: string;
        street: string;
    }
}

interface WaypointProps {
    waypoint: Waypoint
    detailed: boolean
}

const WaypointComponent = (props: WaypointProps) => {

    const { waypoint, detailed } = props;

    if (!detailed) {
        return <WaypointSummary waypoint={waypoint} />
    }
    return <WaypointDetailed waypoint={waypoint} />

}

export default WaypointComponent;
